"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIBE = exports.BUY_OR_RESERVE = void 0;
const BUY_OR_RESERVE = exports.BUY_OR_RESERVE = 'buyOrReserve';
const SUBSCRIBE = exports.SUBSCRIBE = 'subscribe';
//# sourceMappingURL=types.js.map